import { Customers } from 'components/users-and-access';

/** @ngInject */
export default function customersRouter($stateProvider) {
    const customersState = {
        url: '/customers',
        views: {
            contentBody: {
                component: Customers.Component.selector
            }
        }
    };

    $stateProvider
        .state('main.users-and-access.customers', customersState);
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/customers/customers.router.js